"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { ViewModeProvider } from "./context/ViewModeContext";

function PageLogger() {
    const pathname = usePathname();

    useEffect(() => {
        // Log the visit safely
        const logVisit = async () => {
            try {
                await fetch("/api/log-visit", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        path: pathname,
                        referrer: document.referrer
                    })
                });
            } catch (e) {
                // Fail silently
            }
        };

        logVisit();
    }, [pathname]);

    return null;
}

export default function ClientLayout({ children }: { children: React.ReactNode }) {
    return (
        <ViewModeProvider>
            <PageLogger />
            {children}
        </ViewModeProvider>
    );
}
